import React from 'react';
import { Button } from '@mui/material';
import { styled } from '@mui/material/styles';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { BUTTON_COLOR } from '../../../../utils/ColorPicker';

const StyledButton = styled(Button, {
  shouldForwardProp: (prop) => !['custompadding', 'customisedFontSize', 'customBgColor',
     'customMarginTop', 'customMarginLeft', 'disabled'].includes(prop),
})(({ customisedFontSize, customBgColor, customMarginTop, custompadding , customMarginLeft , disabled}) => ({
  padding: custompadding || '3px 25px',
  width: '110px',
  borderRadius: '5px',
  color: disabled ? '#FFFFFF' : '#FFFFFF',
  fontSize:customisedFontSize || '16px',
  textTransform: 'none !important',
  marginRight: '20px',
  fontWeight: '600',
  fontFamily: 'Figtree-Regular',
  marginLeft: customMarginLeft || '0px',
  border: 'none',
  letterSpacing: 'normal',
  backgroundColor: disabled ? `${customBgColor}80` : customBgColor || BUTTON_COLOR, // Less opacity for disabled background
  marginTop: customMarginTop || 0,
  '&:hover': {
    backgroundColor: customBgColor || BUTTON_COLOR,
    border: 'none',
  },
  '&:disabled': {
    color: 'rgba(255, 255, 255, 0.5)',
    backgroundColor: `${customBgColor}80`,
  },
}));

const ModalConfirmButton = ({
  label,
  onClickFn,
  customWidth,
  customFontFam,
  customBgColor,
  customMarginTop,
  customMarginLeft,
  custompadding,
  customisedFontSize,
  disabled = false
}) => {
  const userDomain = useSelector((state) => state?.selectedDomain?.userDomain) || '';

  const buttonStyles = {};

  if (customWidth) {
    buttonStyles.width = `${customWidth}px`;
  }

  if (customFontFam) {
    buttonStyles.fontFamily = customFontFam;
  }

  return (
    <StyledButton
      onClick={onClickFn}
      type='submit'
      className={userDomain && !customFontFam && `${userDomain}_font`}
      style={buttonStyles}
      customBgColor={customBgColor}
      customMarginTop={customMarginTop}
      custompadding={custompadding}
      customMarginLeft={customMarginLeft}
      disabled={disabled}
      customisedFontSize={customisedFontSize}
    >
      {label}
    </StyledButton>
  );
};

ModalConfirmButton.propTypes = {
  customWidth: PropTypes.string.isRequired,
  label: PropTypes.string.isRequired,
  customFontFam: PropTypes.string.isRequired,
  onClickFn: PropTypes.func.isRequired,
  customBgColor: PropTypes.string,
  customMarginTop: PropTypes.number,
  custompadding: PropTypes.string,
};

export default ModalConfirmButton;
